import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from '../styles/ButtonLoader.module.scss';

const cx = classNames.bind(styles);

const ButtonLoader = ({ dark }) => {
  return (
    <div className={cx('loader', { dark })}>
      <span />
      <span />
      <span />
      <span />
    </div>
  );
};

ButtonLoader.defaultProps = {
  dark: false,
};

ButtonLoader.propTypes = {
  dark: PropTypes.bool,
};

export default ButtonLoader;
